export const HEADER_HEIGHT_DEFAULT = 100;
export const HEADER_HEIGHT_DESKTOP = 160;
export const HEADER_HEIGHT_PHONE = 120;

export const ONLY_LOGO_HEADER_HEIGHT_DESKTOP = 80;
export const ONLY_LOGO_HEADER_HEIGHT_PHONE = 60;
